import some from 'lodash/some';
import { ListBooking } from 'types';
import { BookingListContextValue } from './BookingListProvider/types';

export const shouldUpdatePaymentMethod = (booking: ListBooking): boolean => {
  const { hasPendingScheduledPayment, isCreditCardExpired } = booking.flags;
  return hasPendingScheduledPayment && isCreditCardExpired;
};

export const shouldDisplayPaymentMethodUpdateRequiredAlert = ({ filter, bookings }: Partial<BookingListContextValue>): boolean => {
  const isUpcomingFilter = filter === 'upcoming';
  const hasRequiresPaymentMethodUpdateBooking = some(bookings, shouldUpdatePaymentMethod);
  return isUpcomingFilter && hasRequiresPaymentMethodUpdateBooking;
};
